module.exports = __webpack_public_path__ + "img/banner3.a618bb30.jpg";